import "@/App.css";
import Navigation from "@/components/landing/Navigation";
import HeroSection from "@/components/landing/HeroSection";
import FeaturesSection from "@/components/landing/FeaturesSection";
import TiersSection from "@/components/landing/TiersSection";
import CTASection from "@/components/landing/CTASection";

export default function LandingPage() {
  return (
    <div className="noise-overlay bg-void min-h-screen">
      <Navigation />
      <HeroSection />
      <FeaturesSection />
      <TiersSection />
      <CTASection />
    </div>
  );
}
